import * as t from './actionTypes';

const initialState = {
    picklists: {},
    users: [],
    selectedUserId: 0,
}

export default function (state = initialState, action) {
    switch (action.type) {
        
        case t.LOAD_PICKLISTS:
            return Object.assign({}, state, {
                picklists: action.payload
            });
        case t.LOAD_USERS:
            return Object.assign({}, state, {
                users: action.payload
            });
        case t.SET_SELECTED_USER:
            return Object.assign({}, state, {
                selectedUserId: action.payload,
            });
        default:
            return state
    }
}